import { sumBy } from 'lodash';

export default {
  data() {
    return {
      coupons: [
        //1:課程9折券 2:商品券100元 3:課程券100元 4:課程/商品抵用券100元
        {
          name: '課程9折券',
          type: '1',
          qty: 0
        },
        {
          name: '商品券100元',
          type: '2',
          qty: 0
        },
        {
          name: '課程券100元',
          type: '3',
          qty: 0
        },
        {
          name: '課程/商品抵用券100元',
          type: '4',
          qty: 0
        }
      ]
    };
  },
  computed: {
    hasPrograms() {
      return this.programs.length > 0;
    },
    hasProducts() {
      return this.products.length > 0;
    },
    onlyPrograms() {
      return this.hasPrograms && this.products.length === 0;
    },
    onlyProducts() {
      return this.hasProducts && this.programs.length === 0;
    },
    useProgramCouponCount() {
      return sumBy(this.coupons, function(o) {
        if (o.type == 1 || o.type == 3) {
          return o.qty;
        }
      });
    },
    useProductCouponCount() {
      return sumBy(this.coupons, function(o) {
        if (o.type == 2) {
          return o.qty;
        }
      });
    },
    type1UseCount() {
      // 課程9折券使用數量
      return this.coupons[0].qty;
    },
    type2UseCount() {
      // 商品券使用數量
      return this.coupons[1].qty;
    },
    type3UseCount() {
      // 課程100元使用數量
      return this.coupons[2].qty;
    },
    type4UseCount() {
      // 通用券使用數量
      return this.coupons[3].qty;
    },
    programsNum() {
      return this.programs.length;
    },
    productsNum() {
      return this.products.length;
    },
    //coupon券最多使用兩張
    checkCouponsUsedLimitNum() {
      return (
        this.useProductCouponCount +
          this.useProgramCouponCount +
          this.type4UseCount ===
        2
      );
    },
    //只買方案擇一使用
    checkCouponsOnlyProgramsRules() {
      return (
        this.onlyPrograms &&
        this.type4UseCount + this.useProgramCouponCount === 1
      );
    },
    //只買商品擇一使用
    checkCouponsOnlyProductsRules() {
      return (
        this.onlyProducts &&
        this.type4UseCount + this.useProductCouponCount === 1
      );
    }
  },
  watch: {
    coupons: {
      deep: true,
      handler(val) {
        let coupons = val
          .filter(ele => {
            return ele.qty > 0;
          })
          .map(ele => {
            return {
              type: ele.type,
              count: ele.qty
            };
          });
        this.setCoupons(coupons);
      }
    },
    useCoupons: {
      deep: true,
      handler() {
        this.calcOrderPrice();
      }
    },
    hasPrograms(val) {
      if (val === false) {
        this.coupons[0].qty = 0;
        this.coupons[2].qty = 0;

        if (this.productsNum === 0) {
          this.coupons[3].qty = 0;
        }
      }
    },
    hasProducts(val) {
      if (val === false) {
        this.coupons[1].qty = 0;

        if (this.programsNum === 0) {
          this.coupons[3].qty = 0;
        }
      }
    }
  },
  methods: {
    noProgramsToUseCoupons(type) {
      //課程才可用的券
      return (type == 1 || type == 3) && !this.hasPrograms;
    },
    noProductsToUseCoupons(type) {
      //商品才可用的券
      return type == 2 && !this.hasProducts;
    },
    noItemsCanUseCoupons(type) {
      return (
        this.noProgramsToUseCoupons(type) || this.noProductsToUseCoupons(type)
      );
    },
    //同類方案券只能用一張
    programsCouponLimit(type) {
      return (type == 1 || type == 3) && this.useProgramCouponCount == 1;
    },
    //同類商品券只能用一張
    productsCouponLimit(type) {
      return type == 2 && this.useProductCouponCount == 1;
    },
    setCouponQty(type, qty) {
      //設定數量
      let counponIndex = this.coupons.findIndex(ele => {
        return ele.type === type;
      });

      this.$set(this.coupons[counponIndex], 'qty', qty);
    },
    // 確認是否能用課程9折券
    checkCourseCouponUse(type, qty) {
      if (type != 1) {
        return true;
      }

      // 只能使用一張
      if (qty >= 2) {
        return false;
      }

      // 無購買方案
      if (!this.hasPrograms) {
        return false;
      }

      // 已使用課程100元券
      if (this.type3UseCount > 0) {
        return false;
      }

      // 無購買商品 則通用券跟課程9折券擇一
      if (!this.hasProducts && this.type4UseCount > 0) {
        return false;
      }

      return true;
    },
    // 確認是否能用商品券
    checkProductCouponUse(type, qty) {
      if (type != 2) {
        return true;
      }

      // 執行handleMinus時
      if (qty < this.type2UseCount) {
        return true;
      }

      // 無購買商品
      if (!this.hasProducts) {
        return false;
      }

      // 無購買方案 則通用券跟商品券擇一
      if (!this.hasPrograms && this.type4UseCount > 0) {
        return false;
      }

      // 商品券額度為商品小計
      if (this.productCouponAmount + 100 > this.productSubtotal) {
        return false;
      }

      // 不可折超過應收金額
      if (this.receivableAmount - 100 < 0) {
        return false;
      }

      return true;
    },
    // 確認是否能用課程100元券
    checkProgramCouponUse(type, qty) {
      if (type != 3) {
        return true;
      }

      // 執行handleMinus時
      if (qty < this.type3UseCount) {
        return true;
      }

      // 無購買方案
      if (!this.hasPrograms) {
        return false;
      }

      // 已使用課程9折券
      if (this.type1UseCount > 0) {
        return false;
      }

      // 無購買商品 則通用券跟課程100元券擇一
      if (!this.hasProducts && this.type4UseCount > 0) {
        return false;
      }

      // 課程100元券額度為方案小計
      if (this.programCouponAmount + 100 > this.programSubtotal) {
        return false;
      }

      // 不可折超過應收金額
      if (this.receivableAmount - 100 < 0) {
        return false;
      }

      return true;
    },
    // 確認是否能用通用券
    checkCommonCouponUse(type, qty) {
      if (type != 4) {
        return true;
      }

      // 執行handleMinus時
      if (qty < this.type4UseCount) {
        return true;
      }

      // 無購買任何東西
      if (!this.hasProducts && !this.hasPrograms) {
        return false;
      }

      // 無購買商品 則課程券跟通用券擇一 且 額度為方案小計
      if (!this.hasProducts) {
        if (
          this.type1UseCount > 0 ||
          this.type3UseCount > 0 ||
          this.commonCouponAmount + 100 > this.programSubtotal
        ) {
          return false;
        }
      }

      // 無購買方案 則商品券跟通用券擇一 且 額度為商品小計
      if (!this.hasPrograms) {
        if (
          this.type2UseCount > 0 ||
          this.commonCouponAmount + 100 > this.productSubtotal
        ) {
          return false;
        }
      }

      // 購買商品與方案 若已使用商品+課程券就不能用通用券
      if (this.hasProducts && this.hasPrograms) {
        if (
          (this.type1UseCount > 0 || this.type3UseCount > 0) &&
          this.type2UseCount > 0
        ) {
          return false;
        }

        // 使用課程券 額度為商品小計
        if (
          this.type1UseCount + this.type3UseCount > 0 &&
          this.commonCouponAmount + 100 > this.productSubtotal
        ) {
          return false;
          // 無使用課程券 額度為方案小計
        } else if (
          this.type1UseCount + this.type3UseCount == 0 &&
          this.commonCouponAmount + 100 > this.programSubtotal
        ) {
          return false;
        }
      }

      // 不可折超過應收金額
      if (this.receivableAmount - 100 < 0) {
        return false;
      }

      return true;
    },
    updateCouponQty({ type, qty }) {
      // 舊規則
      // 1.只買商品：可用商品券100元 或 課程/商品抵用券  1張
      // 2.買一個商品、一個課程：
      //   (1)可用商品券100元1張+課程9折券 1張
      //   (2)可用商品券100元1張+課程券100元 1張
      //   (3)可用商品券100元1張+課程/商品抵用券100元 1張
      //   (4)可用課程/商品抵用券100元+課程9折券(或 課程券100元) 1張
      // 3.只買方案：可用課程9折券(課程券100元、課程/商品抵用券100元) 1張
      //1:課程9折券 2:商品券100元 3:課程券100元 4:課程/商品抵用券100元

      //規則限制
      // if (
      //   qty !== 0 &&
      //   (this.noItemsCanUseCoupons(type) ||
      //     this.checkCouponsUsedLimitNum ||
      //     this.checkCouponsOnlyProductsRules ||
      //     this.checkCouponsOnlyProgramsRules ||
      //     this.programsCouponLimit(type) ||
      //     this.productsCouponLimit(type))
      // ) {
      //   return;
      // }

      // 新規則
      // 除了課程9折以外都能使用多張
      // 1.只買商品：可用商品券100元 或 課程/商品抵用券 N張
      // 2.只買方案：可用課程9折券(課程券100元、課程/商品抵用券100元) N張
      // 3.買一個商品、一個課程：
      //   (1)可用商品券100元N張+課程9折券 1張
      //   (2)可用商品券100元N張+課程券100元 N張
      //   (3)可用商品券100元N張+課程/商品抵用券100元 N張
      //   (4)可用課程/商品抵用券100元+課程9折券(或 課程券100元) N張

      if (
        qty >= 0 &&
        this.checkCourseCouponUse(type, qty) &&
        this.checkProductCouponUse(type, qty) &&
        this.checkProgramCouponUse(type, qty) &&
        this.checkCommonCouponUse(type, qty)
      ) {
        this.setCouponQty(type, qty);
      }

      return;
    }
  }
};
